import { GlTooltipDirective, GlFormCheckbox, GlLink } from '@gitlab/ui';
import HelpPopover from '~/vue_shared/components/help_popover.vue';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { SQUASH_BEFORE_MERGE } from '../../i18n';
export default {
    name: 'SquashBeforeMerge',
    components: {
        GlFormCheckbox,
        GlLink,
        HelpPopover
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        SafeHtml
    },
    i18n: {
        ...SQUASH_BEFORE_MERGE
    },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        helpPath: {
            type: String,
            required: false,
            default: ''
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'input'
    ],
    computed: {
        tooltipTitle () {
            return this.isDisabled ? this.$options.i18n.tooltipTitle : null;
        },
        popoverOptions () {
            return {
                ...this.$options.i18n.popoverOptions,
                container: this.popoverContainerId
            };
        },
        popoverContainerId () {
            return 'squash-commits-popover';
        }
    }
};
